import { DynamicForm } from "@shared/components/DynamicForm";
import {
  FormConfig,
  FormField,
  FormService,
} from "@shared/services/FormServices";
import React from "react";

interface Props {
  filterFields: FormField[];
  onSubmit: (value: any) => void;
}
function CycleFilters({ filterFields, onSubmit }: Props) {
  const form = FormService.createForm({ fields: filterFields });
  
  const handleSubmit = (value: any) => {
      const submitValues = {
          ...value,
          validator_id: value.validator_id[0],
          supervisor_id: value.supervisor_id[0],
        }
        onSubmit(submitValues);
  };
  const handleReset = () => {
    FormService.resetForm(form, filterFields);
    onSubmit(null);
  }
  const config: FormConfig = {
    fields: filterFields,
    resetButtonText: "Clear",
    showResetButton: true,
    resetOnSubmit: false,
    submitButtonText: "Apply Filter",
    classes: {
        buttonContainer: "flex justify-end border-none",
        fieldContainer: "py-4"
    }
  }
  return (
    <div className="my-2 p-4 border rounded-md">
      <DynamicForm
        fields={filterFields}
        form={form}
        onSubmit={handleSubmit}
        onReset={handleReset}
        config={config}
        gridColumns={4}
      />
    </div>
  );
}

export default CycleFilters;
